import { defineMessages } from "react-intl";

export default defineMessages({
  totalByHour: {
    id: "orderDescription.totalByHour",
    defaultMessage: "Total / hour",
  },
  totalByDay: {
    id: "orderDescription.totalByDay",
    defaultMessage: "Total / day",
  },
  totalByWeek: {
    id: "orderDescription.totalByWeek",
    defaultMessage: "Total / week",
  },
  total: {
    id: "orderDescription.total",
    defaultMessage: "Total",
  },
  advancePayment: {
    id: "orderDescription.advancePayment",
    defaultMessage: "Advance payment",
  },
  client_protection_fee: {
    id: "orderDescription.client_protection_fee",
    defaultMessage: "Client Protection fee",
  },
  client_protection_fee_save: {
    id: "orderDescription.client_protection_fee_save",
    defaultMessage:
      "<bold>Save {savedAmount}</bold> by taking the Ring Twice+ formula",
  },
  client_protection_fee_already_saved: {
    id: "orderDescription.client_protection_fee_already_saved",
    defaultMessage: "You save <bold>{savedAmount}</bold>",
  },
  client_protection_fee_tooltip_info: {
    id: "orderDescription.client_protection_fee_tooltip_info",
    defaultMessage:
      "This fee includes your insurance cover. If anything goes wrong, Ring Twice covers you (damage, litigation, etc.). {learnMore}.",
  },
  client_protection_fee_tooltip_info_leanMore_link: {
    id: "orderDescription.client_protection_fee_tooltip_info_leanMore_link",
    defaultMessage: "https://ringtwice.be/fr/assurance",
  },
  client_protection_fee_tooltip_info_leanMore_link_CTA: {
    id: "orderDescription.client_protection_fee_tooltip_info_leanMore_link_CTA",
    defaultMessage: "Learn More",
  },
  client_protection_fee_saved_tooltip_info: {
    id: "orderDescription.client_protection_fee_saved_tooltip_info",
    defaultMessage:
      "With your Ring Twice+ subscription, you do not pay the 20% Client Protection fee ({savedAmount}) on the service amount.",
  },
});
